import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { SpecraEmptyState } from '@mono/ui-components/lieutenants';
import { applyRateCardEscalation, PricingEngine } from '../../../../../lib/utils/pricingEngine';
import { ClinEditor } from './ClinEditor';
import { ClinsTab } from './ClinsTab';
import { IndirectsTab } from './IndirectsTab';
import { OverviewTab } from './OverviewTab';
import { CostSummary } from './PricingTableParts';
import { TierEditor } from './TierEditor';
import { TiersTab } from './TiersTab';
export function PricingEditorsNode({ pricing, node, clinNumber, tierId, canEdit, byClin, serverTotal, onChange, onNavigate }) {
    const escalation = pricing.rateCard?.escalation;
    const previewPricing = pricing.rateCard && escalation ? {
        ...pricing,
        rateCard: applyRateCardEscalation(pricing.rateCard, 'base', escalation.defaultPct, escalation.perPeriodOverrides)
    } : pricing;
    const preview = new PricingEngine().evaluateScenario(previewPricing);
    const clins = pricing.clinPricing ?? [];
    const configs = pricing.sharedTierConfigs ?? [];
    const clin = clins.find((c)=>c.clinNumber === clinNumber);
    const tier = configs.find((c)=>c.id === tierId);
    return /*#__PURE__*/ _jsx("fieldset", {
        disabled: !canEdit,
        className: "space-y-4",
        children: clinNumber ? clin ? /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(ClinEditor, {
                    clinPricing: clin,
                    rateCard: pricing.rateCard,
                    sharedTierConfigs: configs,
                    onNavigate: onNavigate,
                    onSharedTierChange: (next)=>onChange({
                            ...pricing,
                            sharedTierConfigs: configs.map((c)=>c.id === next.id ? next : c)
                        }),
                    onChange: (next)=>onChange({
                            ...pricing,
                            clinPricing: clins.map((c)=>c.clinNumber === clinNumber ? next : c)
                        })
                }),
                /*#__PURE__*/ _jsx(CostSummary, {
                    clinPricing: preview.clinPricing?.find((c)=>c.clinNumber === clinNumber) ?? clin
                })
            ]
        }) : /*#__PURE__*/ _jsx(SpecraEmptyState, {
            title: "CLIN not found"
        }) : tierId ? tier ? /*#__PURE__*/ _jsx(TierEditor, {
            config: tier,
            configs: configs,
            rateCard: pricing.rateCard,
            referencingClins: clins.filter((c)=>c.laborStructure.type === 'tiered_shared' && c.laborStructure.tierRefs.some((ref)=>ref.sharedTierConfigId === tierId)).map((c)=>c.clinNumber),
            onChange: (next)=>onChange({
                    ...pricing,
                    sharedTierConfigs: configs.map((c)=>c.id === tierId ? next : c)
                })
        }) : /*#__PURE__*/ _jsx(SpecraEmptyState, {
            title: "Shared tier not found"
        }) : node === 'clins' ? /*#__PURE__*/ _jsx(ClinsTab, {
            clins: clins,
            byClin: byClin,
            onNavigate: onNavigate
        }) : node === 'indirects' ? /*#__PURE__*/ _jsx(IndirectsTab, {
            config: pricing.globalIndirectConfig,
            onChange: (globalIndirectConfig)=>onChange({
                    ...pricing,
                    globalIndirectConfig
                })
        }) : node === 'tiers' ? /*#__PURE__*/ _jsx(TiersTab, {
            configs: configs,
            onNavigate: onNavigate
        }) : /*#__PURE__*/ _jsx(OverviewTab, {
            pricing: preview,
            serverTotal: serverTotal
        })
    });
}
